"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  CURRENT_ANALYTICS_VERSION: true,
  MAIN_ANALYTICS_CATEGORIES: true,
  CHAUVET_COLORSTRIP_MINI: true,
  COB_50W: true,
  LALUCE_NATZ_18LED: true,
  LIGHT_STYLE_IDS: true,
  SLIM_PAR_38: true,
  YEESITE_24W: true,
  LIGHT_ONE: true,
  LIGHT_TWO: true,
  LIGHT_THREE: true,
  LIGHT_FOUR: true,
  SPECIAL_EFFECT_LIGHTING_IDS: true,
  AMBIANCE_IDS: true,
  AMBIANCE_TYPE_EFFECT: true,
  AMBIANCE_TYPE_LIGHT: true,
  CULMINATING_MOMENT_INPUT_DECISION_SRCS: true,
  CULMINATING_MOMENT_PRE_COUNT_UP_SRCS: true,
  CULMINATING_MOMENT_DECISIONS_INPUTTED_SRCS: true,
  CULMINATING_MOMENT_SCREEN_COUNTDOWN_COMPLETE_SRCS: true,
  CULMINATING_MOMENT_COUNT_UP_BEGIN_SRCS: true,
  CULMINATING_MOMENT_COUNT_UP_SRCS: true,
  END_TRIGGER_TYPES: true,
  SPECIAL_EFFECT_IDS: true,
  MIN_TIME_SCALE: true,
  TIME_SCALE_RATE_OF_CHANGE: true,
  X_OFFSET_TIME_SCALE: true,
  MAP_OBJECT_SCAN_SPEED_PER_STUDENT: true,
  SECONDS_PER_ACTIVE_STUDENT: true,
  AVAILABLE_LANGUAGES: true,
  TEXT_TO_SPEECH_OPTIONS: true
};
Object.defineProperty(exports, "AMBIANCE_IDS", {
  enumerable: true,
  get: function () {
    return _specialEffects.AMBIANCE_IDS;
  }
});
Object.defineProperty(exports, "AMBIANCE_TYPE_EFFECT", {
  enumerable: true,
  get: function () {
    return _specialEffects.AMBIANCE_TYPE_EFFECT;
  }
});
Object.defineProperty(exports, "AMBIANCE_TYPE_LIGHT", {
  enumerable: true,
  get: function () {
    return _specialEffects.AMBIANCE_TYPE_LIGHT;
  }
});
Object.defineProperty(exports, "AVAILABLE_LANGUAGES", {
  enumerable: true,
  get: function () {
    return _accessibility.AVAILABLE_LANGUAGES;
  }
});
Object.defineProperty(exports, "CHAUVET_COLORSTRIP_MINI", {
  enumerable: true,
  get: function () {
    return _lightStyles.CHAUVET_COLORSTRIP_MINI;
  }
});
Object.defineProperty(exports, "COB_50W", {
  enumerable: true,
  get: function () {
    return _lightStyles.COB_50W;
  }
});
Object.defineProperty(exports, "CULMINATING_MOMENT_COUNT_UP_BEGIN_SRCS", {
  enumerable: true,
  get: function () {
    return _specialEffects.CULMINATING_MOMENT_COUNT_UP_BEGIN_SRCS;
  }
});
Object.defineProperty(exports, "CULMINATING_MOMENT_COUNT_UP_SRCS", {
  enumerable: true,
  get: function () {
    return _specialEffects.CULMINATING_MOMENT_COUNT_UP_SRCS;
  }
});
Object.defineProperty(exports, "CULMINATING_MOMENT_DECISIONS_INPUTTED_SRCS", {
  enumerable: true,
  get: function () {
    return _specialEffects.CULMINATING_MOMENT_DECISIONS_INPUTTED_SRCS;
  }
});
Object.defineProperty(exports, "CULMINATING_MOMENT_INPUT_DECISION_SRCS", {
  enumerable: true,
  get: function () {
    return _specialEffects.CULMINATING_MOMENT_INPUT_DECISION_SRCS;
  }
});
Object.defineProperty(exports, "CULMINATING_MOMENT_PRE_COUNT_UP_SRCS", {
  enumerable: true,
  get: function () {
    return _specialEffects.CULMINATING_MOMENT_PRE_COUNT_UP_SRCS;
  }
});
Object.defineProperty(exports, "CULMINATING_MOMENT_SCREEN_COUNTDOWN_COMPLETE_SRCS", {
  enumerable: true,
  get: function () {
    return _specialEffects.CULMINATING_MOMENT_SCREEN_COUNTDOWN_COMPLETE_SRCS;
  }
});
Object.defineProperty(exports, "CURRENT_ANALYTICS_VERSION", {
  enumerable: true,
  get: function () {
    return _versionDescription.CURRENT_ANALYTICS_VERSION;
  }
});
Object.defineProperty(exports, "END_TRIGGER_TYPES", {
  enumerable: true,
  get: function () {
    return _specialEffects.END_TRIGGER_TYPES;
  }
});
Object.defineProperty(exports, "LALUCE_NATZ_18LED", {
  enumerable: true,
  get: function () {
    return _lightStyles.LALUCE_NATZ_18LED;
  }
});
Object.defineProperty(exports, "LIGHT_FOUR", {
  enumerable: true,
  get: function () {
    return _specialEffectLighting.LIGHT_FOUR;
  }
});
Object.defineProperty(exports, "LIGHT_ONE", {
  enumerable: true,
  get: function () {
    return _specialEffectLighting.LIGHT_ONE;
  }
});
Object.defineProperty(exports, "LIGHT_STYLE_IDS", {
  enumerable: true,
  get: function () {
    return _lightStyles.LIGHT_STYLE_IDS;
  }
});
Object.defineProperty(exports, "LIGHT_THREE", {
  enumerable: true,
  get: function () {
    return _specialEffectLighting.LIGHT_THREE;
  }
});
Object.defineProperty(exports, "LIGHT_TWO", {
  enumerable: true,
  get: function () {
    return _specialEffectLighting.LIGHT_TWO;
  }
});
Object.defineProperty(exports, "MAIN_ANALYTICS_CATEGORIES", {
  enumerable: true,
  get: function () {
    return _versionDescription.MAIN_ANALYTICS_CATEGORIES;
  }
});
Object.defineProperty(exports, "MAP_OBJECT_SCAN_SPEED_PER_STUDENT", {
  enumerable: true,
  get: function () {
    return _sensors.MAP_OBJECT_SCAN_SPEED_PER_STUDENT;
  }
});
Object.defineProperty(exports, "MIN_TIME_SCALE", {
  enumerable: true,
  get: function () {
    return _sensors.MIN_TIME_SCALE;
  }
});
Object.defineProperty(exports, "SECONDS_PER_ACTIVE_STUDENT", {
  enumerable: true,
  get: function () {
    return _sensors.SECONDS_PER_ACTIVE_STUDENT;
  }
});
Object.defineProperty(exports, "SLIM_PAR_38", {
  enumerable: true,
  get: function () {
    return _lightStyles.SLIM_PAR_38;
  }
});
Object.defineProperty(exports, "SPECIAL_EFFECT_IDS", {
  enumerable: true,
  get: function () {
    return _specialEffects.SPECIAL_EFFECT_IDS;
  }
});
Object.defineProperty(exports, "SPECIAL_EFFECT_LIGHTING_IDS", {
  enumerable: true,
  get: function () {
    return _specialEffectLighting.SPECIAL_EFFECT_LIGHTING_IDS;
  }
});
Object.defineProperty(exports, "TEXT_TO_SPEECH_OPTIONS", {
  enumerable: true,
  get: function () {
    return _accessibility.TEXT_TO_SPEECH_OPTIONS;
  }
});
Object.defineProperty(exports, "TIME_SCALE_RATE_OF_CHANGE", {
  enumerable: true,
  get: function () {
    return _sensors.TIME_SCALE_RATE_OF_CHANGE;
  }
});
Object.defineProperty(exports, "X_OFFSET_TIME_SCALE", {
  enumerable: true,
  get: function () {
    return _sensors.X_OFFSET_TIME_SCALE;
  }
});
Object.defineProperty(exports, "YEESITE_24W", {
  enumerable: true,
  get: function () {
    return _lightStyles.YEESITE_24W;
  }
});
var _versionDescription = require("./analytics/versionDescription");
var _leaderboards = require("./constants/leaderboards");
Object.keys(_leaderboards).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _leaderboards[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _leaderboards[key];
    }
  });
});
var _awardTypes = require("./constants/awardTypes");
Object.keys(_awardTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _awardTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _awardTypes[key];
    }
  });
});
var _missionStateConstants = require("./constants/missionStateConstants");
Object.keys(_missionStateConstants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _missionStateConstants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _missionStateConstants[key];
    }
  });
});
var _volumes = require("./constants/volumes");
Object.keys(_volumes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _volumes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _volumes[key];
    }
  });
});
var _actions = require("./constants/actions");
Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _actions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _actions[key];
    }
  });
});
var _deltaClock = require("./constants/deltaClock");
Object.keys(_deltaClock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _deltaClock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _deltaClock[key];
    }
  });
});
var _notableEvents = require("./constants/notableEvents");
Object.keys(_notableEvents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _notableEvents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _notableEvents[key];
    }
  });
});
var _engineeringPanel = require("./constants/engineeringPanel");
Object.keys(_engineeringPanel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _engineeringPanel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _engineeringPanel[key];
    }
  });
});
var _lightStyles = require("./specialEffectDefinitions/lightStyles");
var _specialEffectLighting = require("./specialEffectDefinitions/specialEffectLighting");
var _specialEffects = require("./specialEffectDefinitions/specialEffects");
var _sensors = require("./constants/sensors");
var _accessibility = require("./constants/accessibility");